/**
 * Contacting Primum Support from anywhere in the app: a signed-in, confirmed
 * member is taken to their own support thread, with a draft started when the
 * screen has context to give; anyone else keeps the support form or email.
 *
 * The draft store is the `/state` entry, read by the support thread's composer;
 * the request and source types are the `/model` entry.
 */
export { useContactSupport, useSupportPrompt } from './hooks/useContactSupport';
export { useInquirySupportAction } from './hooks/useInquirySupportAction';
